import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useAuthContext } from '../../contexts/AuthContext';
import { getResults } from '../../services/Master';
import { useTranslation } from 'react-i18next';
import ResultsTable from '../Results/ResultsTable';

const Results = ({ gameToken }) => {
    const [results, setResults] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const { auth } = useAuthContext();
    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true;
        if (gameToken)
            getResults(auth.token, gameToken)
                .then((resultData) => {
                    if (!mounted) return;
                    const userScores = Object.entries(resultData).map(
                        ([key, value]) => ({
                            ...value.results,
                            usertoken: key,
                            player: value.player,
                        })
                    );
                    setResults(userScores);
                })
                .catch((err) => {
                    console.warn(t('error.loadResults'), err.message);
                    enqueueSnackbar(
                        <div>
                            <p>{t('error.loadResults')}</p>
                            <p>{err.message}</p>
                        </div>,
                        {
                            variant: 'error',
                        }
                    );
                });
        return () => {
            mounted = false;
        };
    }, [auth.token, gameToken, enqueueSnackbar, t]);

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <ResultsTable data={results} />
        </div>
    );
};

export default Results;
